export default {
  vacations: [
    ['2025-11-14', '2025-11-14'], // Urnenbeisetzung
    ['2025-12-22', '2026-01-08'], // Weihnachtsferien
    ['2026-02-02', '2026-02-06'], // Semesterferien
    ['2026-03-28', '2026-04-06'], // Osterferien
    ['2026-05-15', '2026-05-15'], // Fenstertag
    ['2026-06-03', '2026-06-03'], // Fenstertag
    ['2026-10-27', '2026-10-30'], // Herbstferien
    ['2026-12-07', '2026-12-07'], // Fenstertag
    ['2026-12-21', '2027-01-09'], // Weihnachtsferien
    ['2027-02-01', '2027-02-05'], // Semesterferien
    ['2027-03-22', '2027-03-26'], // Osterferien
    ['2027-10-25', '2027-10-29'], // Herbstferien
    ['2027-12-23', '2028-01-07'], // Weihnachtsferien
    ['2026-01-16', '2026-01-16'], // Geburtstag Silvia
    ['2026-07-03', '2026-07-03'], // Geburtstag Fabian
    ['2026-08-19', '2026-08-19'], // Geburtstag Peter
    ['2026-07-06', '2026-07-07'], // Stattegg / Burgenland
    ['2026-07-16', '2026-07-17'], // Saalfelden / Bad Goisern
    ['2026-07-20', '2026-08-07'], // Urlaub
    // Geburtstag Marlene = Herbstferien
  ],
  holidays: [
    '2025-11-15', // St. Leopold
    '2025-12-08', // Mariä Empfängnis
    '2025-12-24', // Weihnachten
    '2025-12-25', // Christtag
    '2025-12-26', // Stefanitag
    '2025-12-31', // Silvester
    '2026-01-01', // Neujahr
    '2026-01-06', // Heilige Drei Könige
    '2026-04-20', // Ostermontag
    '2026-05-01', // Staatsfeiertag
    '2026-05-14', // Christi Himmelfahrt
    '2026-06-04', // Frohnleichnam
    '2026-05-25', // Pfingstmontag
    '2026-10-26', // Nationalfeiertag
    '2026-12-08', // Maria Empfängnis
    '2026-12-24', // Weihnachten
    '2026-12-25', // Weihnachten
    '2026-12-26', // Weihnachten
    '2026-12-31', // Weihnachten
    '2027-01-01', // Silvester
  ],
};



//////////////////
// WEBPACK FOOTER
// ./static/js/vacation.js
// module id = 5NQQ
// module chunks = 0